// Subset of Rma Commodity Codes for LRP from RMA ADM A00420
export const RmaLrpCommodityCodes = {
  FEEDER_CATTLE: '0801',
  FED_CATTLE: '0802',
  SWINE: '0815',
} as const;

export type RmaLrpCommodityCode =
  (typeof RmaLrpCommodityCodes)[keyof typeof RmaLrpCommodityCodes];

export function isRmaLrpCommodityCode(
  commodityCode: string
): commodityCode is RmaLrpCommodityCode {
  return Object.values(RmaLrpCommodityCodes).includes(
    commodityCode as RmaLrpCommodityCode
  );
}

// Subset of RMA Commodity Names for LGM from RMA ADM A00420
export const RmaLrpCommodityNames = {
  FEEDER_CATTLE: 'Feeder Cattle',
  FED_CATTLE: 'Fed Cattle',
  SWINE: 'Swine',
} as const;

export type RmaLrpCommodityNames =
  (typeof RmaLrpCommodityNames)[keyof typeof RmaLrpCommodityNames];

/**
 * @deprecated we should really know the commodity code everywhere we know the name
 */
export const RmaLrpCommodityCodeByName = {
  [RmaLrpCommodityNames.FEEDER_CATTLE]: RmaLrpCommodityCodes.FEEDER_CATTLE,
  [RmaLrpCommodityNames.FED_CATTLE]: RmaLrpCommodityCodes.FED_CATTLE,
  [RmaLrpCommodityNames.SWINE]: RmaLrpCommodityCodes.SWINE,
};

export const RmaLrpCommodityNameByCode: Record<
  string, // allow lookup by any rmaCommodityCode
  RmaLrpCommodityNames
> = {
  [RmaLrpCommodityCodes.FEEDER_CATTLE]: RmaLrpCommodityNames.FEEDER_CATTLE,
  [RmaLrpCommodityCodes.FED_CATTLE]: RmaLrpCommodityNames.FED_CATTLE,
  [RmaLrpCommodityCodes.SWINE]: RmaLrpCommodityNames.SWINE,
};
